import { render, staticRenderFns } from "./proteccion-personal-editar.vue?vue&type=template&id=d9efd5a2&scoped=true&"
import script from "./proteccion-personal-editar.vue?vue&type=script&lang=js&"
export * from "./proteccion-personal-editar.vue?vue&type=script&lang=js&"
import style0 from "./proteccion-personal-editar.vue?vue&type=style&index=0&id=d9efd5a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9efd5a2",
  null
  
)

export default component.exports